/**
 * Direktive zum Steuern der Timeline mit einem Slider
 * @class directive_v3sTimelineSlider
 * @memberOf v3sWbtPlayerApp:animation
 * @requires {@link v3sWbtPlayerApp:animation.service_v3sTimelineService}
 */
angular.module('v3sWbtPlayerApp').directive('v3sTimelineSlider', ["v3sTimelineService", "v3sWbtDataService", function (v3sTimelineService, v3sWbtDataService) {
    return {
        restrict: 'E',
        template: "<div></div>",
        link: function (scope, element) {

            var slider = element.find("div")[0];
            noUiSlider.create(slider, {
                start: 1,
                step: 0.01,
                behaviour: 'snap',
                connect: 'lower',
                range: {
                    'min': 0,
                    'max': 1
                }
            });

            var sliderHandle = slider.firstChild.firstChild;

            var disable = function (value) {
                if (value) {
                    slider.setAttribute('disabled', true);
                } else {
                    slider.removeAttribute('disabled');
                } 
            }
            disable(true);

            v3sTimelineService.subscribePlaying(scope, function (progress) {
                if (slider.hasAttribute('disabled')) {                    
                    if (v3sTimelineService.isUserInteractionAllowed() && v3sWbtDataService.getWbt().interactiveTimeline) {
                        disable(false);
                    }

                    v3sTimelineService.setProgressBar({ element: sliderHandle, disable: disable, paramFrom: { left: "0%" }, paramTo: { left: "100%" } });
                }
            });

            slider.noUiSlider.on('slide', function () {
                var oldProgress = v3sTimelineService.setProgress(slider.noUiSlider.get());
                if (oldProgress) {
                    slider.noUiSlider.set(oldProgress);
                }
            });
        }
    }
}]);